export const configurableProfileSections = [
  {
    id: 'demographicInformation',
    label: 'Demographic Information',
  },
  {
    id: 'section9thTo11th',
    label: '9th-11th Grade Coursework',
  },
  {
    id: 'section12th',
    label: '12th Grade Coursework',
  },
  {
    id: 'inProgressCollegeCoursework',
    label: 'In-Progress College Coursework',
  },
  {
    id: 'completedCollegeCoursework',
    label: 'Completed College Coursework',
  },
  {
    id: 'honorsDistinctions',
    label: 'Honors and Distinctions',
  },
  {
    id: 'activitiesExperiences',
    label: 'Activities and Experiences',
  },
  {
    id: 'coalitionEssay',
    label: 'Coalition Essay',
  },
]

export const coreProfileSections = [
  {
    id: 'personalInformation',
    label: 'Personal Information',
  },
  {
    id: 'contactInformation',
    label: 'Contact Information',
  },
  {
    id: 'feeWaiver',
    label: 'Fee Waiver',
  },
  {
    id: 'familyInformation',
    label: 'Family Information',
  },
  {
    id: 'citizenship',
    label: 'Citizenship',
  },
  {
    id: 'highSchoolInformation',
    label: 'High School Information',
  },
  {
    id: 'collegeInformation',
    label: 'College Information',
  },
  {
    id: 'additionalInformation',
    label: 'Additional Information',
  },
]

export const questionsSection = [
  {
    id: 'multipleChoice',
    label: 'Select',
    subLabel: '(Multiple-Choice, True or False, etc.)',
  },
  {
    id: 'shortAnswer',
    label: 'Short Answer',
    subLabel: '(Fewer than 500 Words)',
  },
  {
    id: 'essays',
    label: 'Essay',
    subLabel: '(Greater than 500 Words)',
  },
]

export const testSections = [
  {
    id: 'requirements',
    label: 'Score Requirements',
  },
  {
    id: 'collectScores',
    label: 'Collect Scores from Application Profile',
  },
]

export const testRequirementType = {
  required: 'Test Scores Required',
  optional: 'Test-Optional',
  doNotSend: 'Test-Blind',
}

export const feeWaiverType = {
  ALL: 'All Students',
  NONE: 'Not Applicable',
  US: 'US Citizens / Residents',
}

export const resultFromGET = {
  scid: 2100315,
  firstYearConfiguration: {
    enabled: true,
    profileSections: {
      demographicInformation: false,
      section9thTo11th: false,
      section12th: false,
      inProgressCollegeCoursework: false,
      completedCollegeCoursework: false,
      additionalExams: false,
      englishProficiencyTests: false,
      honorsDistinctions: false,
      activitiesExperiences: false,
      coalitionEssay: false,
    },
    testingPolicy: {
      requirements: null,
      collectScores: false,
    },
    questionsSection: {
      multipleChoice: null,
      shortAnswer: null,
      essays: {
        min: 1,
        max: 5,
      },
    },
  },
  transferConfiguration: {
    enabled: false,
    profileSections: {
      demographicInformation: false,
      section9thTo11th: false,
      section12th: false,
      inProgressCollegeCoursework: false,
      completedCollegeCoursework: false,
      additionalExams: false,
      englishProficiencyTests: false,
      honorsDistinctions: false,
      activitiesExperiences: false,
      coalitionEssay: false,
    },
    testingPolicy: {
      requirements: null,
      collectScores: false,
    },
    questionsSection: {
      multipleChoice: null,
      shortAnswer: null,
      essays: null,
    },
  },
  transferGuidelines: {
    creditHoursRequired: 0,
    coalitionTransferReport: false,
  },
  applicationNotes: {
    body: 'string',
  },
  supplementEssayInfo: {
    body: 'string',
  },
  epTestGuidelines: {
    body: 'string',
  },
  testingPolicyNotes: {
    body: 'string',
  },
  admissionsContactInfo: {
    firstName: 'first',
    lastName: 'last',
    email: 'email@scoir.com',
    countryCode: '+1',
    phoneNumber: '123-456-7890',
  },
  armedForcesFeeWaiverEligibility: {
    feeWaiver: false,
  },
  integrationPartner: 'slate',
  partnerConfiguration: {
    instanceId: 'string',
  },
}
